import ApiConstant from "../../constants/api.constants";
import Helpers from "../../utils/helpers";
import api from "../api";

const baseURL = process.env.REACT_APP_SERVER_ENDPOINT_AURA_CAMERA;

// cache variable
let cachedSites: any = null;
let requestPromise: Promise<any> | null = null;

const getInspectionOverviewSites = async () => {
  try {
    //return cached data if available
    if (cachedSites) {
      return cachedSites;
    }

    // prevent multiple simultaneous calls
    if (!requestPromise) {
      requestPromise = api.get(baseURL + ApiConstant.getOverviewSites);
    }

    const response = await requestPromise;

    if (response && response.data !== undefined && response.data !== null) {
      cachedSites = response.data; // store cache (including empty array)
      return cachedSites;
    }
    // Resolved but unusable body: release the in-flight promise so callers can retry.
    requestPromise = null;
    return undefined;
  } catch (error) {
    Helpers.ConsoleLogError(error);
    requestPromise = null;
    return undefined;
  }
};

const clearOverviewSitesCache = () => {
  cachedSites = null;
  requestPromise = null;
};

const OverviewSitesService = {
  getInspectionOverviewSites,
  clearOverviewSitesCache
};

export default OverviewSitesService;